import { mergeStyles } from "@fluentui/react";

export const mobileBackButton = {
    color: "#097dd5", //microsoft-blue,
    paddingLeft: 0,
    paddingRight: 0,
};

export const mobileBackIcon = {
    paddingLeft: 0,
    marginLeft: 0,
    paddingRight: 0,
    marginRight: 0,
};

export const mobileMoreTopNavIcon = {
    standard: {
        paddingLeft: 0,
        marginLeft: 0,
        marginRight: 5,
        paddingTop: 5,
        paddingBottom: 5,
        color: "#097dd5",
        fontSize: 20,
    },
    hover: {
        backgroundColor: "#f3f2f1",
    }
};

export const mobileMoreStyle = mergeStyles({
    color: "#097dd5",
    marginRight: 5
});

export const mobileMenuRowStyle = {
    marginBottom: 5,
};

export const mobileListItemStyle = {
    height: 55,
}

export const mobileIconStyle = mergeStyles({
    fontSize: 20,
})

export const getPlatform = (): Office.PlatformType | string | null => {
    try {
        if (typeof Office !== "undefined") {
            if (typeof Office.context?.diagnostics?.platform !== "undefined") {
                return Office.context.diagnostics.platform;
            }
            else if (typeof Office.context?.mailbox?.diagnostics?.hostName !== "undefined") {
                return Office.context.mailbox.diagnostics.hostName;
            }
        }
    } catch (error) {
        // Ignore
    }
    return null;
}

export const isMobile = (): boolean => {
    const platform = getPlatform();
    if (platform) {
        return platform === Office.PlatformType.iOS
        || platform === Office.PlatformType.Android
        || platform === "OutlookIOS"
        || platform === "OutlookAndroid";
    }
    return false;
}